<script setup lang="ts">
import { PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import Product from '~/models/Product/Product'

const props = defineProps({
    product: {
        type: Object as PropType<Product>,
        required: true,
    },
    lines: {
        type: Number,
        default: 3,
    },
})

const { product } = toRefs(props)

const emit = defineEmits(['redirectToUrl'])

const formattingTitle = (title: string): string => {
    return title?.replace(new RegExp(` (?=${useI18n().t('stripSpaceSymbol')})`, 'g'), '&nbsp;')
}
</script>

<template>
    <a
        class="product__name notranslate"
        :class="{ 'product__name--2line': lines }"
        :href="product.url"
        :title="product.name"
        data-cy="product-name"
        @click.prevent="emit('redirectToUrl', $event)"
    >
        <h3 v-html="formattingTitle(product.name)"></h3>
    </a>
</template>

<style scoped lang="scss">
.product {
    &__name {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 59px;
        margin: 5px 0;
        overflow: hidden;
        white-space: pre-wrap;
        text-decoration: none;

        h3 {
            font-size: 14px;
            line-height: 18px;
            text-decoration: none;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            margin: 0;
            overflow: hidden;
        }

        &--2line {
            h3 {
                -webkit-line-clamp: 2;
            }
        }
    }
}
</style>
